import { Injectable } from '@angular/core';
import { Moment } from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { Currency } from '../currency';
import { ExchangeRate } from '../exchange-rate';
import { HttpService } from '../service/http.service';
import { BookingPreConfirmationService } from './booking-pre-confirmation.service';
import Decimal from 'decimal.js';
import { SchoolInvoiceService } from '../school-invoice.service';
import * as moment from 'moment';
import { BookingService } from './booking.service';
import { map } from 'rxjs/operators';
import { FormArray, FormBuilder } from '@angular/forms';
import { PaymentToSupplier } from '../payment-to-supplier';
import { PaymentType } from '../payment-type';
import { PaymentReceivedService } from './payment-received.service';
import { PaymentReceived } from '../payment-received';
import { PaymentOrder } from '../payment-order';
import { SchoolInvoice } from '../school-invoice';
import { SchoolInvoiceWithPaymentOrders } from '../school-invoice-with-payment-orders';
import { PaymentToSupplierService } from './payment-to-supplier.service';
import { BookingFinancialState } from '../booking-financial-state';
import { BrazilianFinancialState } from '../brazilian-financial-state';
import { BookingPreConfirmation } from '../booking-pre-confirmation';
import { FinancialStateJsonContainer } from '../financial-state-json-container';
import { FinancialStateType } from '../financial-state-type';

@Injectable({
  providedIn: 'root'
})
export class BookingTransactionsService {

  totalReceivedInEuro: Decimal = new Decimal(0.00);
  // received in base currency
  totalReceived: Decimal = new Decimal(0.00);

  // balance in base currency
  balance: Decimal = new Decimal(0.00);
  productPricesInEuro$: Observable<Decimal>[] = [];
  balanceInEuro: Decimal = new Decimal(0.00);

  receivedPaymentsInBaseCurrency$: Observable<Decimal>[] = [];
  dueAmountByCustomer: Decimal = new Decimal(0.00);
  dueAmountByCustomerInEuro: Decimal = new Decimal(0.00);

  dueAmountByCustomerInBaseCurrency: Decimal = new Decimal(0.00);
  balanceInBaseCurrency: Decimal = new Decimal(0.00);

  billedAmountBySchool: Decimal = new Decimal(0.00);
  billedAmountBySchoolInEuro: Decimal = new Decimal(0.00);

  margin: Decimal = new Decimal(0.00);
  marginInEuro: Decimal = new Decimal(0.00);

  paymentToSupplierForm!: FormArray;
  paymentsToSupplier: PaymentToSupplier[] = [];
  paymentsToSupplierToDelete: PaymentToSupplier[] = [];
  paymentOrders: PaymentOrder[] = [];
  payments: PaymentReceived[] = [];
  paymentsToDelete: PaymentReceived[] = [];

  schoolInvoiceForm: FormArray;
  schoolInvoices: SchoolInvoice[] = [];
  schoolInvoiceToDelete: SchoolInvoice[] = [];

  paymentTypes: PaymentType[] = [];

  balanceToSchoolInEuro: Decimal = new Decimal(0.00);
  paidAmountToSchoolInEuro: Decimal = new Decimal(0.00);
  paidAmountToSchoolInBaseCurrency: Decimal = new Decimal(0.00);

  creatingPaymentReceived = false;
  editingPaymentReceived = false;

  creatingSchoolInvoice = false;
  editingSchoolInvoice = false;

  creatingPaymentToSupplier = false;
  editingPaymentToSupplier = false;

  creatingSchoolInvoiceFile = false;

  ONE_HUNDRED = new Decimal(100);
  financialState!: BookingFinancialState;
  brazilianFinancialState!: BrazilianFinancialState;
  financialStateType: FinancialStateType = FinancialStateType.EUROPE;

  constructor(
    private httpService: HttpService,
    private bookingPreConfirmationService: BookingPreConfirmationService,
    private schoolInvoiceService: SchoolInvoiceService,
    private bookingService: BookingService,
    private paymentReceivedService: PaymentReceivedService,
    private paymentToSupplierService: PaymentToSupplierService,
    private builder: FormBuilder
  ) {
    this.paymentToSupplierForm = builder.array([]);
    this.schoolInvoiceForm = builder.array([]);
  }

  getExchangeRateToEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateToEuro(currency, date, this.bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value, true);
  }

  getExchangeRateFromAnotherCurrency(baseCurrency: Currency, targetCurrency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateWithBaseCurrency(baseCurrency, targetCurrency, date, this.bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value, true);
  }

  getNetExchangeRateFromAnotherCurrency(baseCurrency: Currency, targetCurrency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateWithBaseCurrency(baseCurrency, targetCurrency, date, this.bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value, false);
  }

  calculateBalance() {
    this.dueAmountByCustomer = new Decimal(0.00);
    this.dueAmountByCustomerInBaseCurrency = new Decimal(0.00);
    this.balance = new Decimal(0.00);
    this.balanceInEuro = new Decimal(0.00);
    this.balanceInBaseCurrency = new Decimal(0.00);
    this.productPricesInEuro$ = [];
    if (this.bookingService.booking.preConfirmation) {
      let amounts: Observable<Decimal>[] = [];
      for (let product of this.bookingService.booking.preConfirmation.productList) {
        this.productPricesInEuro$.push(this.getExchangeRateToEuro(product.currency,
          this.bookingService.booking.preConfirmation.confirmationDate == null ? moment() : moment(this.bookingService.booking.preConfirmation.confirmationDate)).pipe(map(
            rate => {
              return product.amount.times(rate.exchangeRate);
            }
          ))
        );
        this.dueAmountByCustomer = this.dueAmountByCustomer.plus(product.amount);
        let dueAmount$ = this.getExchangeRateFromAnotherCurrency(product.currency, this.bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value,
          this.bookingService.booking.preConfirmation.confirmationDate == null ? moment() : moment(this.bookingService.booking.preConfirmation.confirmationDate)).pipe(map(
            rate => {
              return product.amount.times(rate.exchangeRate);
            }
          ));
        amounts.push(dueAmount$);
      }
      forkJoin(this.productPricesInEuro$).subscribe(prices => {
        this.dueAmountByCustomerInEuro = new Decimal(0.00);
        for (let price of prices) {
          this.roundAmount(price);
          this.dueAmountByCustomerInEuro = this.dueAmountByCustomerInEuro.plus(price);
        }
        this.dueAmountByCustomerInEuro = this.dueAmountByCustomerInEuro.round();
        this.balanceInEuro = this.dueAmountByCustomerInEuro.minus(this.totalReceivedInEuro);
      });
      this.balance = this.dueAmountByCustomer.minus(this.totalReceived);
      forkJoin(amounts).subscribe(amounts => {
        for (let amount of amounts) {
          this.roundAmount(amount);
          this.dueAmountByCustomerInBaseCurrency = this.dueAmountByCustomerInBaseCurrency.plus(amount);
        }
        this.dueAmountByCustomerInBaseCurrency = this.dueAmountByCustomerInBaseCurrency.round();
        if (this.receivedPaymentsInBaseCurrency$.length > 0) {
          forkJoin(this.receivedPaymentsInBaseCurrency$).subscribe(received => {
            let receivedTotal = new Decimal(0.00);
            for (let amount of received) {
              this.roundAmount(amount);
              receivedTotal = receivedTotal.plus(amount);
            }
            this.balanceInBaseCurrency = this.dueAmountByCustomerInBaseCurrency.minus(receivedTotal);
          });
        } else {
          //if there is no received payment
          this.balanceInBaseCurrency = this.dueAmountByCustomerInBaseCurrency;
        }
      }
      );
    }
  }

  roundAmount(amount: Decimal) {
    amount = (amount.times(this.ONE_HUNDRED)).round().dividedBy(this.ONE_HUNDRED);
  }

  calculateMargin() {
    this.billedAmountBySchool = new Decimal(0.00);
    this.billedAmountBySchoolInEuro = new Decimal(0.00);
    for (let invoice of this.schoolInvoiceService.invoices) {
      this.billedAmountBySchool = this.billedAmountBySchool.plus(invoice.amount);
      this.billedAmountBySchoolInEuro = this.billedAmountBySchoolInEuro.plus(invoice.amountInEuro!);
    }
    this.margin = this.totalReceived.minus(this.billedAmountBySchool);
    this.marginInEuro = this.totalReceivedInEuro.minus(this.billedAmountBySchoolInEuro);
  }

  updateSchoolInvoices() {
    if (!this.bookingService.booking.id) {
      console.log("updateSchoolInvoices called but no booking id");
      return;
    }
    this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(this.bookingService.booking.id!).subscribe(res => {
      this.schoolInvoiceService.invoices = res;
      this.convertSchoolInvoice();
      //let backend choose it
      this.updateBookingFinancialState(this.bookingService.booking.id!, this.bookingService.booking.preConfirmation!.baseCurrency.id);
    });
  }

  convertSchoolInvoice() {
    for (let invoice of this.schoolInvoiceService.invoices) {
      if (invoice.created) {
        invoice.created = moment(invoice.created);
      }
      invoice.amount = new Decimal(invoice.amount);
      invoice.hidden = true;
    }
  }

  updatePaymentsReceived() {
    this.creatingPaymentReceived = false;
    this.editingPaymentReceived = false;
    this.httpService.getPaymentsReceivedByBooking(this.bookingService.booking.id!).subscribe(res => {
      this.paymentReceivedService.payments = res;
      this.checkDepositPayment(res);
      this.convertPaymentReceived();
    });
  }

  initPaymentsReceived() {
    this.creatingPaymentReceived = false;
    this.editingPaymentReceived = false;
    this.paymentReceivedService.payments = this.bookingService.booking.paymentReceivedList;
    this.checkDepositPayment(this.bookingService.booking.paymentReceivedList!);
  }

  initPaymentsToSchool() {
    this.creatingPaymentToSupplier = false;
    this.editingPaymentToSupplier = false;
    this.paymentToSupplierService.payments = this.bookingService.booking.paymentToSupplierList;
  }

  getPaymentOrders() {
    this.paymentOrders = [];
    this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(this.bookingService.booking.id!).subscribe(res => {
      for (let invoice of res) {
        for (let paymentOrder of invoice.paymentOrders) {
          paymentOrder.invoiceNumber = invoice.invoiceNumber;
          paymentOrder.label = paymentOrder.amount + " " + paymentOrder.currency.isoCode + " " + paymentOrder.invoiceNumber;
          this.paymentOrders.push(paymentOrder);
        }
      }
    });
  }

  checkDepositPayment(payments: PaymentReceived[]) {
    let booking = this.bookingService.booking;
    //do nothing if booking has deposit paid already
    if (booking.depositReceived != null) {
      return;
    }
    let totalPaidInEuro = new Decimal(0);
    for (let payment of payments) {
      totalPaidInEuro = totalPaidInEuro.plus(new Decimal(payment.amountInEuro!));
    }
    let deposit = booking.preConfirmation!.deposit;
    if (deposit && deposit!.toString() == "") {
      deposit = null;
    }
    if (deposit && !totalPaidInEuro.eq(new Decimal(0)) && totalPaidInEuro.gte(this.bookingService.booking.preConfirmation!.deposit!)) {
      this.httpService.setDepositPaidDate(this.bookingService.booking.id!).subscribe(() => {
        this.bookingService.setDepositReceived(moment());
      });
    } else if (!deposit && !totalPaidInEuro.eq(new Decimal(0))) {
      let total = this.getTotalPriceInEuro(booking.preConfirmation!);
      if (totalPaidInEuro.cmp(total) >= 0) {
        this.httpService.setDepositPaidDate(booking.id!).subscribe(() => {
          this.bookingService.setDepositReceived(moment());
        });
      }
    }
  }

  getTotalPriceInEuro(preconf: BookingPreConfirmation) {
    let total = new Decimal(0);
    for (let price of preconf.productList) {
      total = total.plus(price.amountInEuro!);
    }
    return total;
  }

  convertPaymentReceived() {
    for (let paymentReceived of this.paymentReceivedService.payments) {
      if (paymentReceived.created) {
        paymentReceived.created = moment(paymentReceived.created);
      }
      paymentReceived.hidden = true;
      paymentReceived.amount = new Decimal(paymentReceived.amount);
    }
  }

  calculateTotalReceived() {
    this.receivedPaymentsInBaseCurrency$ = [];
    this.totalReceived = new Decimal(0.00);
    this.totalReceivedInEuro = new Decimal(0.00);
    this.bookingPreConfirmationService.totalReceivedInBaseCurrency = new Decimal(0.00);
    this.bookingPreConfirmationService.totalReceivedInSecondCurrency = new Decimal(0.00);
    if (this.paymentReceivedService.payments) {
      for (let payment of this.paymentReceivedService.payments) {
        payment.amount = new Decimal(payment.amount);
        this.totalReceived = this.totalReceived.plus(payment.amount);
        this.totalReceivedInEuro = this.totalReceivedInEuro.plus(payment.amountInEuro!);
        let amountInBaseCurrency = this.getNetExchangeRateFromAnotherCurrency(payment.currency,
          this.bookingPreConfirmationService.preConfirmationForm.get("baseCurrency")!.value,
          moment(payment.date)).pipe(map(rate => {
            return payment.amount.times(rate.exchangeRate);
          }));
        this.receivedPaymentsInBaseCurrency$.push(amountInBaseCurrency);
        amountInBaseCurrency.subscribe(amount => {
          this.bookingPreConfirmationService.totalReceivedInBaseCurrency = this.bookingPreConfirmationService.totalReceivedInBaseCurrency.plus(amount);
        });
        if (this.bookingService.booking.preConfirmation!.secondCurrency) {
          this.getNetExchangeRateFromAnotherCurrency(payment.currency, this.bookingPreConfirmationService.preConfirmationForm.get("secondCurrency")!.value, moment(payment.date)).subscribe(rate => {
            this.bookingPreConfirmationService.totalReceivedInSecondCurrency = this.bookingPreConfirmationService.totalReceivedInSecondCurrency.plus(payment.amount.times(rate.exchangeRate));
          });
        }
      }
    } else {
      console.log("this.paymentReceivedService.payments is null");
    }
  }

  calculateBalanceToSchool() {
    let totalInvoiceInEuro = new Decimal(0);
    for (let invoice of this.schoolInvoiceService.invoices) {
      totalInvoiceInEuro = totalInvoiceInEuro.plus(new Decimal(invoice.amountInEuro!));
    }
    this.balanceToSchoolInEuro = this.totalReceivedInEuro.minus(totalInvoiceInEuro);
  }

  updateTransactions() {
    this.creatingPaymentReceived = false;
    this.editingPaymentReceived = false;
    let bookingId = this.bookingService.booking.id;
    let baseCurrencyId = this.bookingService.booking.preConfirmation!.baseCurrency.id;
    forkJoin({
      paymentsReceived: this.httpService.getPaymentsReceivedByBooking(bookingId!),
      schoolInvoices: this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(bookingId!),
      paymentsToSupplier: this.httpService.getPaymentsToSupplierByBookingId(bookingId!)
    }).subscribe(({
      paymentsReceived,
      schoolInvoices,
      paymentsToSupplier
    }) => {
      this.paymentReceivedService.payments = paymentsReceived;
      for (let payment of this.paymentReceivedService.payments) {
        payment.created = moment(payment.created);
      }
      this.bookingService.booking.paymentToSupplierList = paymentsToSupplier;
      this.paymentToSupplierService.payments = paymentsToSupplier;
      this.schoolInvoiceService.invoices = schoolInvoices;
      this.checkDepositPayment(paymentsReceived);
      this.updateBookingFinancialState(bookingId!, baseCurrencyId);
    });
  }

  updateTotalReceived(paymentsReceived: PaymentReceived[]) {
    this.totalReceived = new Decimal(0);
    this.totalReceivedInEuro = new Decimal(0);
    for (let payment of paymentsReceived) {
      this.totalReceived = this.totalReceived.plus(new Decimal(payment.amount));
      this.totalReceivedInEuro = this.totalReceivedInEuro.plus(new Decimal(payment.amountInEuro!));
    }
  }

  updateBilledAmount(schoolInvoices: SchoolInvoiceWithPaymentOrders[]) {
    this.billedAmountBySchool = new Decimal(0);
    this.billedAmountBySchoolInEuro = new Decimal(0);
    for (let invoice of schoolInvoices) {
      this.billedAmountBySchool = this.billedAmountBySchool.plus(new Decimal(invoice.amount));
      this.billedAmountBySchoolInEuro = this.billedAmountBySchoolInEuro.plus(new Decimal(invoice.amountInEuro!));
    }
  }

  updatePaidAmountToSchool(paymentsToSupplier: PaymentToSupplier[]) {
    this.paidAmountToSchoolInBaseCurrency = new Decimal(0);
    this.paidAmountToSchoolInEuro = new Decimal(0);
    for (let payment of paymentsToSupplier) {
      this.paidAmountToSchoolInBaseCurrency = this.paidAmountToSchoolInBaseCurrency.plus(new Decimal(payment.amount));
      this.paidAmountToSchoolInEuro = this.paidAmountToSchoolInEuro.plus(new Decimal(payment.amountInEuro!));
    }
  }

  updateBookingFinancialState(bookingId: number, baseCurrencyId: number) {
    this.httpService.getBookingFinancialState(bookingId, baseCurrencyId).subscribe(res => {
      let result = res as FinancialStateJsonContainer;
      if (result.type == FinancialStateType.BRAZIL) {
        this.brazilianFinancialState = result.brazilianState;
        this.financialStateType = FinancialStateType.BRAZIL;
      } else {
        this.financialState = result.europeanState;
        this.financialStateType = FinancialStateType.EUROPE;
      }
    }, error => console.error(error));
  }

  //return the type of the dominant payment received type (ING, ELB or other)
  getPaymentReceivedType(): number | null {
    const paymentMap = new Map();
    let payments = this.paymentReceivedService.payments;
    for (let payment of payments) {
      if (!paymentMap.has(payment.paymentType.id)) {
        paymentMap.set(payment.paymentType.id, new Decimal(payment.amountInEuro!));
      } else {
        let oldAmount = new Decimal(paymentMap.get(payment.paymentType.id));
        let newAmount = oldAmount.plus(new Decimal(payment.amountInEuro!));
        paymentMap.set(payment.paymentType.id, newAmount);
      }
    }
    let paymentTypeId = this.findKeyOfHighest(paymentMap);
    return paymentTypeId;
  }

  findKeyOfHighest(map: Map<number, Decimal>) {
    let highestVal: Decimal = new Decimal(0);
    let highestKey: number | null = null;
    for (let [key, value] of map.entries()) {
      if (value.gt(highestVal)) {
        highestVal = value;
        highestKey = key;
      }
    }
    return highestKey;
  }
}
